import {Integer} from 'platform/foundation';
import styled, {keyframes} from 'styled-components';

interface MetricsSkeletonProps {
  /** CSS width, e.g. '100%' or '72px'. */
  width: string;
  /** Height in theme size units (1 unit = 4px). */
  height?: Integer;
}

/**
 * Pulsing placeholder shown while panel metrics are loading.
 * The web design system has no Skeleton component, so the panel ships its own.
 */
export function MetricsSkeleton(props: MetricsSkeletonProps) {
  return <SkeletonBox $width={props.width} $height={props.height ?? 4} aria-hidden />;
}

const pulse = keyframes`
  0% { opacity: 0.45; }
  50% { opacity: 1; }
  100% { opacity: 0.45; }
`;

const SkeletonBox = styled.div<{$width: string; $height: Integer}>`
  width: ${({$width}) => $width};
  height: ${({theme, $height}) => theme.getSize($height)};
  border-radius: ${({theme}) => theme.radii.small};
  background-color: ${({theme}) => theme.colors.palettes.neutral[20][100]};
  animation: ${pulse} 1.4s ease-in-out infinite;
`;
